<template>
    <div id="reportsResults">
        <h3>Registration Report Results</h3>
        <table id="reportsTable">
            <thead>
                <tr>
                    <td>Plate Number</td>
                    <td>Unit Number</td>
                    <td>Make</td>
                    <td>Model</td>
                    <td>VIN</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in results">
                    <td>{{item.MVLicenseNo}}</td>
                    <td>{{item.MVIncareOfName}}</td>
                    <td>{{item.MVMake}}</td>
                    <td>{{item.MVModel}}</td>
                    <td>{{item.MVVin}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
      name: 'reportsResults',
      data () {
        return {
          results: this.$store.getters.reportResults
        }
    },
      methods: {

      },
      mounted () {
        if (this.$store.getters.getUserStatus === 'Admin') {
          this.$nextTick(() => {
            let internalBusinessListingsReportTable = $('#reportsTable').DataTable({
              responsive: true,
              bLengthChange: false,
              dom: 'Bfrtip',
              buttons: [
                {
                  extend: 'csv',
                  filename: 'report'
                },
                {
                  extend: 'pdfHtml5',
                  filename: 'report',
                  title: 'report',
                  orientation: 'landscape',
                  pageSize: 'LEGAL'
                }
              ]
            })
          })
        } else {
          window.location = './#/search'
        }
      }
    }
</script>
<style scoped>

</style>     


// WEBPACK FOOTER //
// src/components/reportsResults.vue